import OrderChildProductCard from './OrderChildProductCard';

export default OrderChildProductCard;
